module.exports = __webpack_public_path__ + "img/sc-2p-2024.e2ee53bc.png";